import React from "react";
import { Check, X } from "lucide-react";
import { PROBLEM } from "../mock";
import Reveal from "./Reveal";

const ProblemSection = () => {
  return (
    <section className="relative py-20 lg:py-28 bg-[#0A1220]">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-3xl">
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            {PROBLEM.headline}
          </h2>
          <p className="mt-5 text-lg text-[#8290A8] leading-relaxed">{PROBLEM.copy}</p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          <Reveal>
            <div className="h-full rounded-2xl border border-[#29354A] bg-[#121A28] p-7">
              <p className="text-[#8290A8] font-semibold mb-6">{PROBLEM.traditional.title}</p>
              <ul className="space-y-4">
                {PROBLEM.traditional.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-[#8290A8]">
                    <span className="mt-0.5 w-5 h-5 rounded-full bg-[#29354A]/60 flex items-center justify-center shrink-0">
                      <X className="w-3 h-3 text-[#8290A8]" />
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="h-full rounded-2xl border border-[#10C98A]/40 bg-[#172031] p-7 relative overflow-hidden">
              <div className="absolute -top-16 -right-16 w-40 h-40 bg-[#10C98A]/15 blur-3xl rounded-full" />
              <p className="font-display text-[#13D99A] font-bold text-lg mb-6">{PROBLEM.renn.title}</p>
              <ul className="space-y-4">
                {PROBLEM.renn.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-[#F5F7FB]">
                    <span className="mt-0.5 w-5 h-5 rounded-full bg-[#10C98A]/20 flex items-center justify-center shrink-0">
                      <Check className="w-3 h-3 text-[#13D99A]" />
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
